import React from 'react';
import AppState from './context/app/AppState';

import AppWrapper from './AppWrapper';

import './App.scss';

function App() {

    return (
        <AppState>
            <AppWrapper />
        </AppState >
    );
}

export default (App);
